// src/pages/Contact.tsx
import "@/styles/marketing.css";
import MarketingHeader from "@/components/marketing/MarketingHeader";
import MarketingFooter from "@/components/marketing/MarketingFooter";

const CHANNELS = [
  {
    id: "01",
    title: "In-app coach",
    eta: "Usually minutes",
    body: "Fastest route for anything about your training, plan or account — message your coach in the app and the team picks up whatever the AI can't.",
    action: null,
  },
  {
    id: "02",
    title: "Email support",
    eta: "Within 24h",
    body: "Billing, account issues, or anything technical.",
    action: { label: "support@inputperformanceai.com", href: "mailto:support@inputperformanceai.com" },
  },
  {
    id: "03",
    title: "Privacy & data",
    eta: "GDPR / ICO",
    body: "Data access requests, deletion, or privacy concerns.",
    action: { label: "privacy@inputperformanceai.com", href: "mailto:privacy@inputperformanceai.com" },
  },
];

export default function Contact() {
  return (
    <div className="mk">
      <MarketingHeader />

      <main>
        {/* Hero */}
        <section className="border-b" style={{ borderColor: "var(--mk-line)" }}>
          <div className="max-w-screen-xl mx-auto px-5 pt-20 pb-16">
            <div className="mk-label mb-6" style={{ color: "var(--mk-signal)" }}>
              Contact
            </div>
            <h1 className="mk-display max-w-3xl" style={{ fontSize: "clamp(36px, 6vw, 68px)" }}>
              Humans reply here.
            </h1>
            <p className="mt-7 max-w-xl text-[16px] leading-relaxed" style={{ color: "var(--mk-muted)" }}>
              No ticket queues, no "we've escalated your case". A small UK team
              that reads everything and answers fast.
            </p>
          </div>
        </section>

        {/* Channels */}
        <section className="border-b" style={{ borderColor: "var(--mk-line)" }}>
          <div className="max-w-screen-xl mx-auto px-5 py-16 md:py-24">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-px" style={{ background: "var(--mk-line)" }}>
              {CHANNELS.map((ch) => (
                <div key={ch.id} className="p-8 md:p-10 flex flex-col" style={{ background: "var(--mk-carbon)" }}>
                  <div className="flex items-baseline justify-between mb-6">
                    <span className="mk-mono text-[13px] font-medium" style={{ color: "var(--mk-signal)" }}>
                      {ch.id}
                    </span>
                    <span className="mk-label" style={{ fontSize: 9 }}>
                      {ch.eta}
                    </span>
                  </div>
                  <h3 className="mk-display mb-3" style={{ fontSize: 19 }}>
                    {ch.title}
                  </h3>
                  <p className="text-[14px] leading-relaxed flex-1" style={{ color: "var(--mk-muted)" }}>
                    {ch.body}
                  </p>
                  {ch.action && (
                    <a
                      href={ch.action.href}
                      className="mk-mono mt-8 text-[12px] break-all hover:text-[#009e59] transition-colors"
                      style={{ color: "var(--mk-ink)", borderBottom: "1px solid var(--mk-line-2)", paddingBottom: 6 }}
                    >
                      {ch.action.label}
                    </a>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Company info */}
        <section>
          <div className="max-w-screen-xl mx-auto px-5 py-16 md:py-20">
            <div className="flex items-center gap-4 mb-8">
              <span className="mk-label">Registered</span>
              <span className="flex-1 h-px" style={{ background: "var(--mk-line)" }} />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-[14px]" style={{ color: "var(--mk-muted)" }}>
              <div>
                <div className="mk-label mb-3" style={{ fontSize: 9 }}>Company</div>
                <p style={{ color: "var(--mk-ink)" }}>Input Performance Ltd</p>
                <p>Registered in England and Wales</p>
              </div>
              <div>
                <div className="mk-label mb-3" style={{ fontSize: 9 }}>ICO registration</div>
                <p className="mk-mono text-[13px]">ZC036976</p>
              </div>
              <div>
                <div className="mk-label mb-3" style={{ fontSize: 9 }}>Registered office</div>
                <p>5 Kympton Gardens</p>
                <p>GU34 5JL, United Kingdom</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <MarketingFooter />
    </div>
  );
}
